import { getMonthName } from "@helpers/dateHelpers";
import classNames from "classnames";
import styles from "./Assessments.module.css";

export const DateBox = ({ date }: DateBoxProps): JSX.Element => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, month, day] = date.split("-");

    const dayOfMonth = day;
    const monthName = getMonthName(Number(month)).slice(0, 3).toUpperCase();

    const classes = classNames(
        styles.dateBoxBackground,
        "px-5",
        "py-4",
        "is-flex",
        "is-flex-direction-column",
        "is-justify-content-center",
        "is-align-items-center"
    );

    return (
        <div className={classes}>
            <p className="has-text-weight-bold is-size-5">{dayOfMonth}</p>
            <p>{monthName}</p>
        </div>
    );
};

interface DateBoxProps {
    date: string;
}
